import "../Styles/Reviews.css";
import ImageScroller from "../Components/imageScroll/Scroller";
import { ScrollerData } from '../Components/imageScroll/ScrollerData';
import '../Styles/Scroller.css'

function quality() {

  return (
    <div className="quality-section" id="quality">
      <div className="rw-text-content">
        <p className="rw-text-title">
          <span className="rw-text-num">QUALITY POLICY</span>
        </p>
        <p className="rw-text-format">
          <span className="rw-text-quote1">''</span>
          <span className="rw-quality">We are committed to enhance customer satisfaction in utility products through its
            life cycle, by continually improving the internal process/system and engaging interested parties
            in the development process.
          </span>
          <span className="rw-text-quote2">''</span>
        </p>

        <div className="Reviews-image-section">
          <p className="rw-text-title-01">
            <span className="rw-text-num_01">Variety of Premium Natural Granites</span>
          </p>
          <ImageScroller images={ScrollerData} />
        </div>
      </div>
    </div>
  );
}

export default quality;